<template>
  <div>
    <s-pageheader title="电费订单" />
    <ak-model-filter-card model="electricityOrder" @search="search" @reset="reset" />
    <ak-model-card model="electricityOrder" :perPage="10" :page.sync="page" :filters="filters" />
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader/PageHeader.vue'
import Bus from '@/assets/js/eventBus'
export default {
  components: {
    's-pageheader': PageHeader
  },
  data () {
    return {
      filters: {},
      page: 1
    }
  },
  methods: {
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = filters // 修改modelTable的查询条件会自动触发刷新
    },
    reset () {
      this.page = 1
      this.filters = {}
      Bus.$emit('reset', '')
    }
  }
}
</script>

<style>

</style>
